export default (notification) => {
  console.log('FooBar Event: ', notification);
};
